import React from 'react';

import { asset } from 'Services/BaseHelpers';

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { children } = this.props;

        return (
            <div className="min-h-screen bg-app-blue flex">
                <div className="md:w-2/5 flex flex-col">
                    <div className="p-4 md:p-8 lg:p-12">
                        <img src={asset('images/logo.png')} className="h-16" />
                    </div>

                    <div className="flex-1 flex items-center justify-center">
                        {children}
                    </div>
                </div>

                <div className="hidden md:flex items-center justify-center flex-1">
                    <img src={asset('images/awards.png')} />
                </div>
            </div>
        );
    };
}
